import {useMutation, useQueryClient} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import {getLocalStorage} from '@/Utils/CommonUtils';

interface SendMessagePayload {
  user_key: string;
  message?: string;
  file?: File | null;
}

interface ApiResponse {
  status: 'success' | 'error';
  data: any;
}

export function useSendTicketMessage(ticketId: number) {
  const queryClient = useQueryClient();

  const sendMessage = async (
    payload: SendMessagePayload,
  ): Promise<ApiResponse> => {
    const token = await getLocalStorage('access_token');

    const formData = new FormData();
    formData.append('user_key', payload.user_key);
    if (payload.message) formData.append('message', payload.message);
    if (payload.file) formData.append('file', payload.file);

    const response = await ChessRestClient.post<ApiResponse>(
      `/user_raised_issues/ticket/${ticketId}/reply`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    if (response.data.status !== 'success') {
      throw new Error('Failed to send message');
    }

    return response.data;
  };

  return useMutation(sendMessage, {
    onSuccess: () => {
      queryClient.invalidateQueries(['ticketMessages', ticketId]);
    },
  });
}
